import { GroupQuestionResponseV1Enums } from "@pulse/pulse-rpcs/lib/respondent/groupQuestionResponseV1";
import { SubmittedResponseEnums } from "@pulse/pulse-rpcs/lib/respondent/submittedResponse";
import { Instance, types } from "mobx-state-tree";

export const SingleSelectResponseV1Model = types.model(
  "SingleSelectResponseV1Model",
  {
    singleSelectAnswer: types.string,
  },
);

export const createSingleSelectResponseV1Model = (
  singleSelectResponse:
    | SubmittedResponseEnums.Response.Version1Enums.ResponseTypeV1.SingleSelect
    | GroupQuestionResponseV1Enums.ChildResponse.SingleSelect,
): Instance<typeof SingleSelectResponseV1Model> => {
  return SingleSelectResponseV1Model.create({
    singleSelectAnswer: singleSelectResponse.answer,
  });
};
